import { Component, OnInit } from '@angular/core';
import { UsuarioParametrizado } from '../Modelos/UsuarioParametrizado';
import { ParametrizacionService } from './parametrizacion.service';

declare let mostrarToast: Function;
declare let mostrarLoader: Function;
declare let ocultarLoader: Function;
declare let soloLetrasSinEspacios: Function;

@Component({
  selector: 'app-parametrizacion',
  templateUrl: './parametrizacion.component.html'
})
export class ParametrizacionComponent implements OnInit {

  usuario: UsuarioParametrizado;
  usuarioABuscar: string;

  constructor(private parametrizacionService: ParametrizacionService) { }

  ngOnInit() {
    this.usuario=null;
    this.usuarioABuscar="";
    ocultarLoader();
  }

  soloLetrasSinEspacios(modelo, propiedad){
    if(modelo[propiedad])
      modelo[propiedad]=soloLetrasSinEspacios(modelo[propiedad]);
  }

  async consultarUsuario(){
    mostrarLoader();
    this.usuario=await this.parametrizacionService.consultarUsuario(this.usuarioABuscar);
    if(!this.usuario.login){
      mostrarToast("No se encuentra usuario en soligespro con el código de usuario digitado, revise e intente nuevamente.");
      this.usuario=null;
    }
    ocultarLoader();
  }

  async crearUsuario(){
    mostrarLoader();

    if(!(this.usuario.codigoUsuarioSISE === '')){
    let respuesta=(this.usuario.existe)
    ?await this.parametrizacionService.actualizarUsuarioSoligespro(this.usuario)
    :await this.parametrizacionService.crearUsuarioSoligespro(this.usuario);

    if(respuesta){
      this.usuario=null;
      this.usuarioABuscar="";
    }

    mostrarToast((respuesta)?"Usuario actualizado correctamente.":"Ocurrió un error.");
    }
    else{
      mostrarToast("El Campo Cod Usuario SISE es obligatorio.");
    }

    ocultarLoader();
  }
}
